<svg viewBox="0 0 24 24" aria-hidden="true">
  <rect x="3" y="3" width="8.5" height="8.5" fill="#F25022" />
  <rect x="12.5" y="3" width="8.5" height="8.5" fill="#7FBA00" />
  <rect x="3" y="12.5" width="8.5" height="8.5" fill="#00A4EF" />
  <rect x="12.5" y="12.5" width="8.5" height="8.5" fill="#FFB900" />
</svg>
